import React__default from 'react';

const usePagination = (initialPageIndex = 0, initialPageSize = 10) => {
  const [pageIndex, setPageIndex] = React__default.useState(initialPageIndex);
  const [pageSize, setPageSize] = React__default.useState(initialPageSize);
  return {
    pageIndex,
    pageSize,
    setPageIndex,
    setPageSize
  };
};

export { usePagination };
//# sourceMappingURL=usePagination.js.map
